enum FoodType {
  Breakfast = 1,
  Lunch = 2,
  Snack = 3
}

export default FoodType;
